export default __webpack_public_path__ + "static/media/warning--detour-or-construction-ahead--g1.0dad4882.png";